export const SET_INSTANCE = 'setInstance'
export const SET_AUTHORIZATION = 'setAuthorization'



// WEBPACK FOOTER //
// ./src/store/constant.js